export default __webpack_public_path__ + "static/media/11.Hydrant-Box.4d47808f.jpg";